import TimeVerticalBars from "./TimeVerticalBars";

export default TimeVerticalBars;
